import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Lifestyle inflation after 3 years of San Francisco",
  "description": "",
  "published": "2018-08-14T00:00:00.000Z",
  "redirect_from": ["/blog/lifestyle-inflation-3-years-san-francisco/swizec/8565"],
  "categories": "Personal, Thoughts",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A good friend from college visited this weekend, and we got to chatting about life, beer in hand, as one does. He just bought a 2 bed 2 bath in Portugal, surfs every weekend, and plans to pay off his mortgage in 4 to 5 years working remote jobs for San Francisco. 👏`}</p>
    <p>{`That same day, I almost didn't feel bad eating out twice in the same Saturday. That shit adds up.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`All my friends are grown up buying houses and apartments in Europe and here I am in San Francisco happy that I can almost comfortably afford avotoast without guilt 😂`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1029103030652743685"
      }}>{`August 13, 2018`}</a></blockquote>
    <p>{`Another college friend just bought a ranch, and some horses, and a freaking Bobcat excavator. Cash. A third is halfway into saving up for a second apartment… or maybe a long sabbatical.`}</p>
    <p>{`🤔`}</p>
    <blockquote>
      <p parentName="blockquote">{`Well I wasn't in San Francisco, you know`}</p>
      <p parentName="blockquote">{`~ Friend`}</p>
    </blockquote>
    <p>{`Friend makes a good point. Making almost San Francisco salaries from Slovenia makes for some fantastic income arbitrage.`}</p>
    <p>{`The play goes like this 👇`}</p>
    <ol>
      <li parentName="ol">{`Become self employed`}</li>
      <li parentName="ol">{`Find startup clients in San Francisco`}</li>
      <li parentName="ol">{`Stay under $100,000/year in revenue`}</li>
      <li parentName="ol">{`Pay 2% income tax due to entrepreneurship stimulus gotchas`}</li>
      <li parentName="ol">{`Sock away some 60% of your income`}</li>
      <li parentName="ol">{`Live like a king`}</li>
    </ol>
    <p>{`It's a good play. Working very well for many of my friends. Some living life on the racetrack, others surfing ocean waves in Portugal, traveling around Europe, or playing around on their ranch with a Bobcat excavator. Damn.`}</p>
    <p>{`Then there's me.`}</p>
    <p>{`Tired, grinding, hustling, stepping over poop on my way to the office every morning. San Francisco 🤘`}</p>
    <p>{`Honestly, I don't know why. Some perverse combination of pride, hubris, and optimizing for future potential. While my friends reached their ceilings, complain about having no one to talk to about their problems because everyone around them is like `}<em parentName="p">{`"Pfft, you're rich, how dare you speak of problems when we're barely getting by on less than `}{`\\`}{`\\`}{`\\`}{`$20k a year?"`}</em>{`, I often feel like I haven't even reached the starting line in this damn town. There's soooooo much further to go 😨`}</p>
    <h2 {...{
      "id": "so-how-expensive-is-san-francisco-anyway"
    }}>{`So how expensive is San Francisco anyway?`}</h2>
    <p>{`Pretty expensive, let's see…`}</p>
    <p>{`3 years ago, I published a look at my Toshl data: `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/this-is-how-lifestyle-inflation-snuck-up-on-me/swizec/6630"
      }}>{`How lifestyle inflation snuck up on me`}</a>{`. There I discovered that my cost of living has been going up about 2x year over year. Part of that was business expenses, part was moving out of my mum's place, part of it was flying between Slovenia and San Francisco a lot.`}</p>
    <p>{`Four months later, I moved to San Francisco for realz, and I haven't left since. Paying rent in one of the most expensive parts of town because it saves on transportation `}<em parentName="p">{`and`}</em>{` time, funding a side hustle, and generally worrying less and less about the little expenses.`}</p>
    <p>{`6 years ago, I thought $5 was a big expense.`}</p>
    <p>{`3 years ago, I thought $20 was reasonable but worth considering.`}</p>
    <p>{`This Saturday, I paid $60 for brunch, and it didn't even register. Although I did just have coke and everyone else had cocktails, so how's an even split even remotely fair 🤔`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/08/CleanShot_2018-08-13_at_23.56.24.png",
        "alt": null
      }}></img></p>
    <p>{`The annualized projection for 2018 is terrifying. $206k what the hell? O.o`}</p>
    <p>{`I sure hope that's because I'm frontloading a bunch of expensive crap and paid off a bunch of old taxes in one go. 😅`}</p>
    <h2 {...{
      "id": "where-does-all-that-money-go"
    }}>{`Where does all that money go`}</h2>
    <p><a parentName="p" {...{
        "href": "https://toshl.com"
      }}>{`Toshl`}</a>{` to the rescue! Where `}<em parentName="p">{`does`}</em>{` it all go?`}</p>
    <p>{`Let's look at a typical month… July.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/08/CleanShot_2018-08-14_at_00.21.14.png",
        "alt": null
      }}></img></p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`$2530`}</inlineCode>{` for airplane tickets so my mum and sister can come visit in September.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$289`}</inlineCode>{` car rental for a friend's birthday weekend`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$88`}</inlineCode>{` for Uber`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$1000`}</inlineCode>{` into index funds`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$608`}</inlineCode>{` on Facebook ads`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$900`}</inlineCode>{` on freelancers`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$92`}</inlineCode>{` because I had to renew a bunch of domains`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$2900`}</inlineCode>{` my contribution to the joint account, covers rent, groceries, and cleaners for our apartment`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$617`}</inlineCode>{` on meals at restaurants`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$111`}</inlineCode>{` on takeout meals`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$100`}</inlineCode>{` on coffee shops`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$88`}</inlineCode>{` on energy drinks`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$35`}</inlineCode>{` on CogniTea`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$778`}</inlineCode>{` on various apps and SaaS services I use`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$155`}</inlineCode>{` boxing gym`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$64`}</inlineCode>{` lifting gym`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$247`}</inlineCode>{` on leisure stuff`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$158`}</inlineCode>{` on health & personal care, `}<a parentName="li" {...{
          "href": "https://swizec.com/blog/tried-weed-performance-enhancement/swizec/8487"
        }}>{`most of which was Eaze`}</a></li>
      <li parentName="ul"><inlineCode parentName="li">{`$27`}</inlineCode>{` on useful books`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$19`}</inlineCode>{` for clothes because I had to buy a sweater to throw away at the marathon`}</li>
    </ul>
    <p>{`Everyone likes to make fun of me for paying rent in San Francisco, but when you share that with your girlfriend, it's not even that bad. I spent more than that flying my mum and sister here for a visit.`}</p>
    <p>{`Them restaurant prices, that's where it really adds up. And I'm sure I don't quite need all those apps and services, but San Francisco runs on that shit. Take my phone away, and it's like you chopped off an arm.`}</p>
    <h2 {...{
      "id": "its-not-that-bad"
    }}>{`It's not that bad!`}</h2>
    <p>{`My decision to live in San Francisco isn't `}<em parentName="p">{`that`}</em>{` bad at all! Sure, it completely changed my perception of money… nothing seems expensive anymore, and any price you give makes me say `}<em parentName="p">{`"Sure, that makes sense"`}</em>{`, but take away being generous to my family and running a side business, and July comes down to some $7000, a cool grand of which is long-term savings.`}</p>
    <p>{`That's not so bad, is it? 🤔`}</p>
    <p>{`No wonder I can't buy a house…`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      